import React from 'react'
import { Tab } from 'semantic-ui-react'
import AllSKPD from '../../global/AllSKPD';
import AllOPD from '../../global/AllOPD';

const panes = [
   { 
     menuItem: 'SKPD', 
     render: () => <Tab.Pane attached={false}><AllSKPD /></Tab.Pane> 
   },
   { 
      menuItem: 'OPD', 
      render: () => <Tab.Pane attached={false}><AllOPD /></Tab.Pane> 
   }
]

const Orgcom = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default Orgcom;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_org/Orgcom.js